import React, { useCallback, useMemo } from 'react';
import ReactFlow, {
  Background,
  Controls,
  MiniMap,
  useNodesState,
  useEdgesState,
  addEdge,
  Position,
} from 'react-flow-renderer';

const initialNodes = [
  {
    id: 'corp',
    type: 'default',
    position: { x: 300, y: 0 },
    data: {
      label: (
        <div className="bg-white border border-orange-600 rounded-lg p-2 w-52 shadow">
          <div className="w-12 h-12 rounded-full bg-gray-300 mx-auto mb-2" />
          <div className="font-bold text-sm text-center">Corporate HQ</div>
          <div className="text-xs text-center text-gray-500">Global Strategy</div>
        </div>
      ),
    },
    sourcePosition: Position.Bottom,
    targetPosition: Position.Top,
  },
  {
    id: 'sales',
    position: { x: 100, y: 150 },
    data: {
      label: (
        <div className="bg-white border border-orange-400 rounded-lg p-2 w-52 shadow">
          <div className="w-12 h-12 rounded-full bg-gray-300 mx-auto mb-2" />
          <div className="font-bold text-sm text-center">Sales Division</div>
          <div className="text-xs text-center text-gray-500">Revenue Growth</div>
        </div>
      ),
    },
    sourcePosition: Position.Bottom,
    targetPosition: Position.Top,
  },
  {
    id: 'tech',
    position: { x: 300, y: 150 },
    data: {
      label: (
        <div className="bg-white border border-orange-400 rounded-lg p-2 w-52 shadow">
          <div className="w-12 h-12 rounded-full bg-gray-300 mx-auto mb-2" />
          <div className="font-bold text-sm text-center">Tech Division</div>
          <div className="text-xs text-center text-gray-500">Engineering & AI</div>
        </div>
      ),
    },
    sourcePosition: Position.Bottom,
    targetPosition: Position.Top,
  },
  {
    id: 'hr',
    position: { x: 500, y: 150 },
    data: {
      label: (
        <div className="bg-white border border-orange-400 rounded-lg p-2 w-52 shadow">
          <div className="w-12 h-12 rounded-full bg-gray-300 mx-auto mb-2" />
          <div className="font-bold text-sm text-center">HR Division</div>
          <div className="text-xs text-center text-gray-500">People & Culture</div>
        </div>
      ),
    },
    targetPosition: Position.Top,
  },
];

const initialEdges = [
  { id: 'e1-2', source: 'corp', target: 'sales' },
  { id: 'e1-3', source: 'corp', target: 'tech' },
  { id: 'e1-4', source: 'corp', target: 'hr' },
];

export default function EtAccountPlanFlowSample() {
  const [nodes, setNodes, onNodesChange] = useNodesState(initialNodes);
  const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges);

  const onConnect = useCallback(
    (params) => setEdges((eds) => addEdge({ ...params, animated: true }, eds)),
    [setEdges]
  );

  return (
    <div style={{ height: '80vh', width: '100%' }} className="bg-gray-100 p-2">
      <ReactFlow
        nodes={nodes}
        edges={edges}
        onConnect={onConnect}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        fitView
      >
        <Background gap={16} color="#eee" />
        <Controls />
        <MiniMap />
      </ReactFlow>
    </div>
  );
}